import { render, staticRenderFns } from "./AiCurricularBuilderModal.vue?vue&type=template&id=4d123610&scoped=true"
import script from "./AiCurricularBuilderModal.vue?vue&type=script&lang=js"
export * from "./AiCurricularBuilderModal.vue?vue&type=script&lang=js"
import style0 from "./ai-builder/ai-builder.css?vue&type=style&index=0&id=4d123610&prod&scoped=true&lang=css&external"
import style1 from "./AiCurricularBuilderModal.vue?vue&type=style&index=1&id=4d123610&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d123610",
  null
  
)

export default component.exports